import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";

import { ShopForm } from "../components";
import { useShop, useUpdateShop } from "../hooks";

type IUpdateShop = {
  id: string;
};

export const UpdateShop: React.FC = () => {
  const { id } = useParams<IUpdateShop>();
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);
  const { data, refetch } = useShop(+id!);

  const { form, submit, loading } = useUpdateShop({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le client a été modifié avec succès");
    },
    onError(message) {
      toast.error(message);
    },
  });

  useEffect(() => {
    if (data) {
      form.setValue("name", data.shop.result?.name);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }
  return (
    <>
      <Header
        title={"Boutique"}
        subtitle="Modifier les informations de la boutique"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/shop/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <ShopForm loading={loading} form={form} submit={submit} />
      </div>
    </>
  );
};
